import { useMemo } from 'react'

import { Room } from '@/core/models/room.model'

import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById, selectConsultationCreateRequestTracker, selectNewlyCreatedConsultationId } from '@/redux/reducers/consultation.reducer'
import { selectRoomByConsultationId } from '@/redux/reducers/room.reducer'
import { useGetConsultationQuery } from '@/core/services/consultation'
import { skipToken } from '@reduxjs/toolkit/query'

export function useEmergencyConsultationState(emergencyRoom: Room | null) {
  const { data: emergencyConsultation } = useGetConsultationQuery(emergencyRoom?.currentConsultation ?? skipToken)

  const emergencyConsultationId = emergencyConsultation?._id
  const consultationRoom = useAppSelector((state) => (emergencyConsultationId ? selectRoomByConsultationId(state, emergencyConsultationId) : undefined))

  const newlyCreatedConsultationId = useAppSelector(selectNewlyCreatedConsultationId)
  const consultationCreateRequestTracker = useAppSelector(selectConsultationCreateRequestTracker)

  const isCreatingConsultation = consultationCreateRequestTracker.loading

  return {
    consultationRoom,
    emergencyConsultation,
    emergencyConsultationId,
    isCreatingConsultation,
    newlyCreatedConsultationId,
  }
}
